import { render, staticRenderFns } from "./PosReplacement.vue?vue&type=template&id=0810d922"
import script from "./PosReplacement.vue?vue&type=script&lang=js"
export * from "./PosReplacement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports